'use strict';
import ComplectWidget from './ComplectWidget.html';

const target = document.getElementById('complectWidgetApp');
const complectWidget = new ComplectWidget({
    target: target,
    data: {
        sessid: BX.bitrix_sessid(),
        timer: null,
        ready: false,
        fields: {
            name: '',
            image: '',
            price: 0,
            price_result: 0,
        },
        items: [],
        extra_access: '',
    }
});

complectWidget.on('send', ( data )=>{
    let { url_ajax, sessid } = complectWidget.get();
    BX.ajax({
        showPreloader: true,
        url: url_ajax,
        data: {...data, url_ajax, sessid },
        method: 'POST',
        dataType: 'json',
        timeout: 30,
        async: true,
        processData: true,
        scriptsRunFirst: true,
        emulateOnload: true,
        start: true,
        cache: false,
        onsuccess: function (data) {
            complectWidget.set(data);
            complectWidget.fire('received', data);
        },
        onfailure: function (data) {
            console.warn(data);
        }
    });
});

export default complectWidget;
